<template>
  <div class="p-lg pb-leftSquiggleHeight">
    <h1>Party Summary Card</h1>
    <div class="p-base mb-xl bg-signableBrandColours-white flex flex-col gap-base">
      <PartySummaryCard
        v-for="party in parties"
        :party="party"
        :title="party.title"
        :key="party.id"
      />
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { PartySummaryCard } from '@/components/ui/envelopeCreate/steps/summary/PartySummaryCard';

const parties = ref([
  {
    title: 'Party 1 - name only',
    id: '1',
    email: 'party1@gmail.com',
    message: null,
    password: null,
    role: 'signer',
  },
  {
    title: 'Party 2 - name, role & password',
    id: '2',
    email: 'party@gmail.com',
    password: 'Password123',
    message: null,
    role: 'signer',
  },
  {
    title: 'Party 3 - name, role & message',
    id: '3',
    email: 'party3@gmail.com',
    password: null,
    message: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. In sagittis justo quis accumsan faucibus. In hac habitasse platea dictumst. Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    role: 'signer',
  },
  {
    title: 'Party 4 - name, role, password & message',
    id: '4',
    email: 'party3@gmail.com',
    password: 'Password123',
    message: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. In sagittis justo quis accumsan faucibus. In hac habitasse platea dictumst. Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    role: 'signer',
  },
]);
</script>
